import { PaginatedResponse } from './pagination';

export enum ApiApplicationType {
  AppLauncher = 'appLauncher',
}

export type ApiPaginatedApplicationLinksResponse = PaginatedResponse & {
  results?: ApiApplicationLink[];
};

/** Application link response object. */
export interface ApiApplicationLink {
  /** Type of the application link. Currently, only appLauncher is supported. AppLauncher is a type of application that is launched from the Eagle Eye Networks web application. */
  type: ApiApplicationType;
  /**
   * Name of the application.
   * @example "Eagle Eye Networks"
   */
  name: string;
  /**
   * Category of the application.
   * @example "Access Control"
   */
  category: string;
  /**
   * URL to access the application.
   * @format url
   * @example "https://webapp.eagleeyenetworks.com"
   */
  accessUrl: string;
  /**
   * Logo URL of the application.
   * @format url
   * @example "https://s3.amazonaws.com/brand-assets/myapp/logo.png"
   */
  logoUrl: string;
  /**
   * Icon URL of the application.
   * @format url
   * @example "https://s3.amazonaws.com/brand-assets/myapp/icon.png"
   */
  iconUrl?: string;
}

export type ApplicationLinkParams = {
  /** Type of the application link. Currently, only appLauncher is supported. AppLauncher is a type of application that is launched from the Eagle Eye Networks web application.
   */
  type: ApiApplicationType.AppLauncher;
  /** Use "-name" to sort results in descending order. Use "+name" and to sort results in ascending order.
   */
  sort?: string;
  pageToken?: string;
  pageSize?: number;
};
